import { render, staticRenderFns } from "./CompareSliderMod.vue?vue&type=template&id=1af3845e"
import script from "./CompareSliderMod.vue?vue&type=script&lang=js"
export * from "./CompareSliderMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports